var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "C2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#73DDA2;}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4099",
    className: "st0",
    d: "M2,0h16c1.1,0,2,0.9,2,2v16c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.9,11.5c-0.1,0.9-0.4,1.6-1,2.2c-0.6,0.6-1.4,0.8-2.4,0.8c-1.1,0-2-0.4-2.6-1.1S3,11.6,3,10.4V9.9 C3,9,3.1,8.4,3.4,7.7s0.7-1.1,1.2-1.4s1.2-0.6,1.9-0.6c1,0,1.8,0.3,2.4,0.8s0.9,1.3,1,2.2H8.1c0-0.6-0.2-1-0.5-1.2S7,7.1,6.5,7.1 c-0.6,0-1,0.2-1.3,0.6c-0.3,0.4-0.4,1.1-0.4,2v0.6c0,0.9,0.1,1.6,0.4,2s0.7,0.6,1.3,0.6c0.5,0,0.9-0.1,1.2-0.4s0.4-0.6,0.5-1.2h1.7 V11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.7,14.2h-5.8v-1.2l2.8-2.9c0.4-0.4,0.7-0.8,0.8-1.1c0.1-0.3,0.3-0.6,0.3-0.9c0-0.4-0.1-0.7-0.3-0.9 S14,6.9,13.7,6.9c-0.4,0-0.7,0.1-0.9,0.4s-0.3,0.6-0.3,1h-1.7c0-0.5,0.1-1,0.4-1.4s0.6-0.8,1.1-1s1-0.4,1.5-0.4 c0.9,0,1.6,0.2,2,0.6s0.7,1,0.7,1.8c0,0.4-0.1,0.9-0.3,1.3c-0.2,0.4-0.6,0.9-1.1,1.5l-1.9,2H17v1.5H16.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2);
export default __webpack_public_path__ + "static/media/C2.a0d9798811630add56ae5119258439bb.svg";
export { ForwardRef as ReactComponent };